import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    pageIndex: 1,
    pageSize: 10,
    globalSearch: "",
    sorting: null,
  },
  sortedColumn: null,
  sortedDirection: null,
  topicList: [],
  isLoadingTopics: false,
};

const gestioneTopicsSlice = createSlice({
  name: "gestioneTopicsSlice",
  initialState,
  reducers: {
    setIsLoadingTopics: (state: any, action) => {
      state.isLoadingTopics = action.payload;
    },
    setTopics: (state: any, action: any) => {
      state.topicList = [...action.payload];
    },
    nextPageTopics: (state) => {
      state.filters.pageIndex++;
    },
    setPageTopicsAndSize: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload.page ?? state.filters.pageIndex,
        pageSize: action.payload.size ?? state.filters.pageSize,
      });
    },
    setPageTopics: (state, action) => {
      state.filters.pageIndex = action.payload;
    },
    setSizeTopics: (state, action) => {
      state.filters.pageSize = action.payload;
    },
    setSearchTermTopics: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        globalSearch: action.payload,
      });
    },

    setSorting: (state, action) => {
      state.sortedColumn = action.payload.sortedColumn;
      state.sortedDirection = action.payload.sortedDirection;
      Object.assign(state.filters, {
        pageIndex: 1,
        sorting: action.payload.sorting,
      });
    },
    resetFiltersTopics: () => {
      return initialState;
    },
  },
});

export const {
  nextPageTopics,
  setPageTopics,
  setSizeTopics,
  setSearchTermTopics,
  setSorting,
  resetFiltersTopics,
  setTopics,
  setPageTopicsAndSize,
  setIsLoadingTopics,
} = gestioneTopicsSlice.actions;

export default gestioneTopicsSlice.reducer;
